import { Country } from "../model/Country";
import { Service } from "../../../core/impl/Service";
import { CountriesManager } from "../manager/CountriesManager";
import { Context } from "../../../core/impl/Context";
import { CountryDetectionVO } from "../model/CountryDetectionVO";
import { getLogger } from "@goodgamestudios/logger";
import { WorldAssignmentTrackingConstants } from "../../../TrackingConstants";
import { WorldAssignmentError } from "../../../error/WorldAssignmentError";
import { WorldAssignmentErrorCodes } from "../../../error/WorldAssignmentErrorCodes";
import {
    getCountryCodeByPresetInstance,
    getCountryCodeByFriendInvite,
    getCountryCodeByDefaultInstance
} from "../helpers/CountryUtils";
import { runCountryDetection } from "./CountryDetector";
import { parseCountries } from "../parsers/CountryXMLParser";
import { forceEnglishForSupportAgents } from "../../../../support-login-hydra-hack";

const logger = getLogger("WorldAssignment.CountriesController");


export const loadCountryConfig = async(trackingCallback?: (state: string) => void): Promise<void> => {
    if (trackingCallback) {
        trackingCallback(WorldAssignmentTrackingConstants.COUNTRY_XML_START);
    }
    logger.debug("loadCountryConfig: load country.xml from", Context.instance.globals.countriesConfigUrl);
    const service = new Service(Context.instance.globals.countriesConfigUrl);
    return service.load()
        .then((payload) => {
            if (trackingCallback) {
                trackingCallback(WorldAssignmentTrackingConstants.COUNTRY_XML_END);
            }
            const countries: Country[] = parseCountries(payload);
            Context.instance.get(CountriesManager).initCountries(countries);
        })
        .catch(() => {
            throw new WorldAssignmentError(
                WorldAssignmentErrorCodes.COUNTRY_FAILED_TO_LOAD,
                "Failed to load country.xml from " + Context.instance.globals.countriesConfigUrl
            );
        });
}

export const detectCountry = async(): Promise<Country> => {
    logger.debug("detectCountry: START");
    const config = Context.instance.globals;
    const manager = Context.instance.get(CountriesManager);
    const countryDetectionVO = new CountryDetectionVO(
        config.browserLanguage,
        config.timezoneOffset,
        config.countryCodeFromNetworkCookie,
        config.countryCodeFromQueryString,
        getCountryCodeByPresetInstance(config.presetInstanceId),
        getCountryCodeByFriendInvite(config.zoneIdFromFriendInviteCode, config.countryCodeFromFriendInviteCode),
        getCountryCodeByDefaultInstance(Context.instance.networkSettings.defaultInstanceId),
        config.fakeGeoIpResponse,
        config.alsoDetectUnavailableCountries
    );
    const {country, factor} = await runCountryDetection(countryDetectionVO, manager);
    manager.detectionFactor = factor;
    manager.currentCountry = forceEnglishForSupportAgents(country, config.isHydraLogin);
    return  manager.currentCountry ;
}



